<template>
	<div id="userManage"  class="public-content clearfix" >
		<div class='userMangeTitle'>
			成员管理
		</div>
		<!-- 新版成员管理 -->

		<div id='userManage_left'>
			<div class='userManage_left_t'>
				操作记录
			</div>
			<!-- 时间轴 -->
			<div class='userManage_left_c userManage_content_style'>
				<div class='filterTab' ref='filterTab'>
					 <el-date-picker
			            v-model="dateList"
			            range-separator="至"
			            type="daterange"
			            size='mini'
			            style="width: 210px;margin-right:20px;"
			            value-format="yyyy-MM-dd" format="yyyy-MM-dd"
			            start-placeholder="开始月份"
			            @change='getDataChange'
			            end-placeholder="结束月份">
		         	</el-date-picker>
					  <!-- 操作类型 -->
					   <el-select v-model="getOperationDataForm.type" placeholder="请选择" size='mini' class='selectStyle' clearable filterable
					   		@change = "handleSelectChange"
					   >
					    <el-option
					      v-for="item in operationLogTypeList"
					      :key="item.type"
					      :label="item.name"
					      :value="item.type">
					    </el-option>
					  </el-select>

					  <!-- 成员列表 -->
					   <el-select v-model="getOperationDataForm.accountId" placeholder="请选择" size='mini' class='selectStyle' clearable filterable
					   		@change = "handleSelectChange"
					   >
					    <el-option
					      v-for="item in operationLogLogAccountList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>

					  <!-- 操作板块 -->
					   <el-select v-model="getOperationDataForm.plate" placeholder="请选择" size='mini' class='selectStyle' clearable filterable
					   		@change = "handleSelectChange"
					   >
					    <el-option
					      v-for="item in operationLogLogPlateList"
					      :key="item.type"
					      :label="item.name"
					      :value="item.type">
					    </el-option>
					  </el-select>
					  <div class='searchFor'>
					  	 <el-input size='mini' style='width: 180px;' v-model='getOperationDataForm.search'
									placeholder='请输入条件检索' @keyup.enter.native='getOperationLog' clearable @clear='getOperationLog'
									>
								 <i slot="suffix" class="el-icon-search searchTableData" @click='getOperationLogs' ></i>
						</el-input>
					  </div>
				</div>
					<div id="timeLine" ref='timeLine' v-loading='timeDataLoading'> 
						<el-scrollbar class="default-scrollbar  timeLine_scroll">
						  	<div class='timeItem' v-for='(item,index) in timeLineList' :key='item.id'>
						  		<div class='timeItem_head'>
						  			<span class='dot'>{{item.titleNum}}</span>
						  			<span class='mainTime'>{{item.date}}</span>
						  		</div>
						  		<div class='head_line'></div>
						  		<div class='timeItem_content' v-for='(i,indexs) in item.child' :key='i.id'>
						  			<span class='item_dot'></span>
						  			<!-- :style='returnStyle(i.id)' -->
						  			<div class='item_line head_line' v-if='!((index===timeLineList.length-1)&&(indexs===item.child.length-1))'  :ref='"line_"+i.id'></div>
						  			<div class='hourTime'>
						  				{{i.time}}
						  			</div>
						  			<div class='item_detailed'  :ref='"deleted_"+i.id'>
						  				<span class='detailed_title'>{{i.name}}</span>
						  				<span class='detailed_text'>{{i.log}}</span>
						  				<div class='popper__arrow_s'></div>
						  			</div>
						  		</div>
						  	</div>
						  	<div class='isComplete'>
						  		{{completeText}}
						  	</div>
						  	
						</el-scrollbar>
						<!-- <div class='notData' v-if='!timeLineList.length'>
						  	当前无数据
						</div> -->
					</div>
					
			</div>
			
		</div>
		<div id='userManage_right'>
			<el-row class='userManage_right_t'>
				<el-col :span='12' class='userManage_right_t_t'>全部成员</el-col>
				<el-col :span='12' class='operation'>
					<span @click="tjcyClick"><img src="/static/icon/new_menbur.png" alt="">添加成员</span>
					<span @click="jeglClick" class='roleManger'><img src="/static/icon/new_role.png" alt="">角色管理</span>
				</el-col>
			</el-row>
			<div class='userManage_right_content userManage_content_style'>
				<el-scrollbar class="default-scrollbar">
					<div class='scrollTop'>
						<div class='userManage_right_content_item' v-for='(i,index) in userListData' :key='index'>
							<span class='item_n'>{{i.roleName}}<span v-if='i.childList&&i.childList.length'>({{i.childList.length}})</span></span>
							<div class='item_child'  v-if='i.childList&&i.childList.length'>
								<div class='item_child_item' v-for='item in i.childList' :key='item.id'>
									<span class='dot_name'>
										{{item.firstText}}
										<img 
											src="/static/icon/new_disable.png" 
											v-if='item.isEnable===0' 
											@mouseenter.stop = 'handleAllEnter(item,0)'
											@mouseleave.stop = 'handleAllLeave(item)'
											alt=''>
										<img 
											src="/static/icon/new_suo.png" 
										
											@mouseenter.stop = 'handleAllEnter(item,0)'
											@mouseleave.stop = 'handleAllLeave(item)'
											v-if='item.protectionBook===1&&item.isEnable!==0' 
											alt=''>
									</span>
									<span class='dot_text' 
										  @mouseenter.stop = 'handleAllEnter(item,1)'
										  @mouseleave.stop = 'handleAllLeave(item)'>
										<el-dropdown trigger="click"
											 v-if='item.buttons&&item.buttons.length'
											  @command="handleCommand">
										      <span class="el-dropdown-link" >
										        {{item.userName}}<i class="el-icon-arrow-down el-icon--right"></i>
										      </span>
										      <el-dropdown-menu slot="dropdown">
										        <el-dropdown-item v-for='k in item.buttons' :key='k.id' :command='{a:k,b:item}'>{{k.name}}</el-dropdown-item>
										        <el-dropdown-item :command='{a:"inEable",b:item}'>{{item.isEnable===1?"禁用":"取消禁用"}}</el-dropdown-item>
										      </el-dropdown-menu>
									    </el-dropdown>
									    <span v-else>{{item.userName}}</span>
									</span>

									<!-- hover效果 isUserMessageShow-->
									<el-card v-show='item.isUserMessageShow' class='messageNoteStyle'>
										{{ item.messageNote }}
									</el-card>
								</div>
							</div>
							<div class='noUser' v-else>
								暂无成员
							</div>
						</div>
					</div>
				</el-scrollbar>
			</div>
		</div>
		
		
		<!-- 添加成员弹出层 -->
		<el-dialog :title="title" :visible.sync="dialog.modal" width="520px" :close-on-click-modal="false" class='default-dialog'> 
			<div class="form-item-public">
				<el-form  label-width="80px" ref="modalData" :model="modalData" :rules="dialogRules">
					<el-form-item prop="userLoginName" label="手机号:">
						<el-input v-model="modalData.userLoginName" size="small" placeholder="请输入手机号!" :disabled='isEditer'></el-input>
					</el-form-item>
					<el-form-item prop="userName" label="设置姓名:">
						<el-input v-model="modalData.userName" size="small" placeholder="请输入姓名!"></el-input>
					</el-form-item>
					<el-form-item prop="fkRoleIds" label="选择角色:">
						<el-select v-model="modalData.fkRoleIds" size="small" placeholder="请选择角色" filterable multiple>
							<el-option v-for='item in userSelectOption' :label="item.name" :value="item.id" :key='item.id'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item  label="账套权限:">
						<el-select v-model="modalData.protectionBook" size="small" placeholder="请选择">
							<el-option v-for='item in protectionBookList' :label="item.name" :value="item.id" :key='item.id'></el-option>
						</el-select>
					</el-form-item>
					<!-- 1是 所有数据  2指定   之后1  之前2-->
					<el-form-item  label="查看范围:">
						<el-radio v-model="modalData.dataScope" label="1">全部范围</el-radio>
  						<el-radio v-model="modalData.dataScope" label="2">指定范围</el-radio>
  						<div class='choiceChange' style='padding-top: 20px;' v-show='modalData.dataScope==="2"'>
  							 <el-date-picker
						      type="month"
						      style='width: 150px;'
						      size='small'
						      v-model='dataRangeChoise'
						      @change='handleDataRangeChoiseChange'
						      format='yyyy年MM期'
						      placeholder="选择期数">
						    </el-date-picker>

						    <el-select v-model="modalData.designatedScope" size="small" placeholder="请选择"  style='width: 150px;margin-left: 5px;'>
								<el-option  label="及以后的数据" value="1"></el-option>
								<el-option  label="及以前的数据" value="2"></el-option>
							</el-select>
							<div style='line-height: 20px;padding-top: 10px;color: #999;'>
								*指定范围后，该成员将无权进入包含范围外数据的年报、季报、月份所涉及的账簿、报表、凭证、出纳等数据页面，统计图表也将不完整，请谨慎设置
							</div>
  						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer-right">
				<el-button size="small" @click="dialog.modal = false">取消</el-button>
				<el-button size="small" class='minButton' @click="addRolesMethod">确定</el-button>
			</div>
		</el-dialog>

		<!-- 同步到账套弹出层 -->
		<el-dialog title="同步角色到账套" :visible.sync="modifyUserBy_B" width="420px" :close-on-click-modal="false" class='default-dialog'> 
			<div class="form-item-public">
				<el-form  label-width="100px" ref="modifyUserBy_BForm" :model="modifyUserBy_BForm" :rules="dialogRules_XG">
					<el-form-item  label="是否指定账套:">
						<el-switch
						  v-model="isSelectShow"
						  active-text="是"
						  inactive-text="否">
						</el-switch>
					</el-form-item>
					<el-form-item  label="账套名称:" v-if='isSelectShow'>
						<el-select v-model="modifyUserBy_BForm.setOfBookId" size="small" placeholder="请选择角色" filterable>
							<el-option v-for='item in allBooks' :label="item.bookName" :value="item.bookId" :key='item.bookId'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item  label="角色名称:">
						<el-select v-model="modifyUserBy_BForm.roleList" size="small" placeholder="请选择" filterable multiple>
							<el-option v-for='item in userSelectOption' :label="item.name" :value="item.id" :key='item.id'></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer-right">
				<el-button size="small" @click="modifyUserBy_B = false">取消</el-button>
				<el-button size="small" class='minButton' @click="handleSaveGo">确定</el-button>
			</div>
		</el-dialog>
		<!-- 角色管理弹出框 -->
		<el-dialog title="角色权限管理" :visible.sync="dialog.modal1" width="1200px" :close-on-click-modal="false"  maxHeight='500px' class='userManage_dialog default-dialog'>
			<!-- 自定义数据权限功能 -->
			<div id="roleAuthor" v-loading="userLoading">
				<el-row>
					<el-col :span="4">
						<div class="role-ist">
							<el-scrollbar class="default-scrollbar">
								<div v-for='(item,index) in userSelectOption' class="item" :key='item.id' @click='getUserID(item)'
								 :class="{'active':clickActive==item.id}">
									<span class="role-item-list" v-if='isTextShow[index]'>{{item.name}}</span>
									<input v-else v-model='item.name' @blur='handleblur(item,index)' 
									 @focus = 'handlefocus($event)'
									 class='userInput' ref='userInput'
									></input>
									<i class="el-icon-edit" @click.stop='editUser(item,index)' v-if='isTextShow[index]'></i>
									<i class="el-icon-error" @click.stop='deleteUser(item)' v-if='isTextShow[index]'></i>
								</div>
								<div style=''>
									<el-button type="default" icon="el-icon-plus" @click.stop='addUserAdd' size='mini' ></el-button>
								</div>
							</el-scrollbar>
						</div>
						
					</el-col>
					<el-col :span="20" class='clearfix role_right'>
						<div style='line-height: 30px;padding-bottom:10px' class='clearfix'>
							<span>角色名称：</span>
							<el-input size='mini' placeholder='请输入新角色'  v-model='roleInputValue'  ref='roleInput'
									style='width: 280px;'
							></el-input >
							<!--   -->
							<el-button class='minButton fr' size='mini' v-for='i in buttonList' :key='i.id'
										@click='modifyUserBy_B=true' v-if='buttonList.length'
							>{{i.name}}</el-button>
						</div>
						<role-list v-if="dialog.modal1" :roleId="roleId" :roleInputValue='roleInputValue' @on_success='handleblurSuccess' :oldName='oldName'></role-list>
						
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import publicTable from '@/components/publicTable';
	import roleList from '@/components/dialog/roleList';
	
export default {
	components:{
		publicTable,roleList
	},
	data(){
		return {
			isSelectShow:false,
			isEditer:false,         // 是否是修改状态
			dataRangeChoise:new Date(),         // 查看范围时间
			///messageNote:"哈哈哈",      // 成员管理信息提示
			completeText:"",
			protectionBookList:[
				{name:"随时进入",id:"0"},
				{name:"验证进入",id:"1"},
			],
			radio: '1',
			title:"添加成员",  // 弹出框题目
			timeDataLoading:false, // 时间轴加载
			dateList:[new Date(),new Date()], // 日期数值
			getOperationDataForm:{  // 获取操作记录条件
				type:"",      // 日志类型
				accountId:"",     // 成员id
				plate:"",        // 操作的板块
				start:"",      // 开始时间 全部时间不赋值 格式xxxx-xx-xx
				end:"",         // 结束时间 全部时间不赋值
				search:"", // 搜索内容
				date:"",
				currentPage:"",
			},
			operationLogTypeList:[], // 操作类型
			operationLogLogAccountList:[],    // 成员列表
			operationLogLogPlateList:[], // 操作板块
        value: '',
        isSearchInputShow: false,      // 是否显示搜索框
			timeLineList:[],
			roleInputValue:'',
			isRoleInputShow: false,     // 添加角色框
			roleId:'',
			buttons: [],          // 根据权限获取按钮
			modifyUserBy_B: false,   // 修改B类成员弹框控制
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			modifyUserBy_BForm: {// 同步菜单
				roleList:[],
				setOfBookId:"",
			},
			refresh: true,                // 刷新
			onceBoolean: true,
			treeChecked: [],      // 当前选中权限管理
			userLoading: false,   // 角色管理loading
			clickActive: '',    // 当前选中ID
			nowName: '',      // 当前修改角色的名字，用于判断是否修改
			isTextShow: [],    // 修改角色功能显示隐藏
			form: {
				userSelect: '',
			},
			userForm: {
				name: '', // 角色名字
				id: '', // 角色ID
				menuIds: '', // 菜单树ID
			},
			treeDatas: [],
			userSelectOption: [],
			title:'成员管理',
			admin:'admin',
			dialog:{
				modal:false,
				modal1:false,
				modal2:false
			},
			modalData:{
				userLoginName:'',
				userName:'',
				fkRoleIds:[],
				protectionBook:"0",
				dataScope:"1",
				designatedScope:"2",
				designatedValue:""

			},
			dialogRules:{
				userLoginName:[{ required: true, message: '电话号码不能为空！'}],
				userName:[{ required: true, message: '姓名不能为空！'}],
				fkRoleIds:[{ required: true, message: '角色不能为空！'}],
			},
			dialogRules_XG: {
				userName:[{ required: true, message: '姓名不能为空！'}],
				fkRoleIds:[{ required: true, message: '角色不能为空！'}],
			},
			tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					key: 0,						// 渲染Table
					config: [{
							label: '姓名',
							value: 'userName',
							show: 'normal',
							width: 160,
							fixed: true
						},{
							label: '手机号',
							value: 'userLoginName',
							show: 'normal',
							fixed: true
						},{
							label: '角色',
							value: 'roles',
							show: 'normal',
							fixed: true
						},{
							label: '是否启用成员',
							value: 'isEnable',
							show: 'template',
							width: 140,
						},{
							label: '开启账套保护',
							value: 'protectionBook',
							show: 'template',
						},{
							label: '操作',
							value: 'buttons',
							show: 'template',
							width: 250
						}],
					operation: {
						label: '操作',
						value: 'operation',
						data: []
					},

					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					},
					renderHeader: this.renderHeader,            // 自定义表头方法
				},
				nowTab: {},   // 当前选中的角色
				nowRoleId: '',  // 当前下拉框选中的角色ID
				userListData:[],       // 所有角色
				buttonList:[],
		}
	},
	created(){
		this.getOperationDataForm.start = this.$util.formatDate.format(this.dateList[0], 'yyyy-MM-dd');
		this.getOperationDataForm.end = this.$util.formatDate.format(this.dateList[1], 'yyyy-MM-dd');
		this.init();
		this.getUser();	
		this.getButton();
		this.getOperationLogType();
		this.getAllUserData();
		this.getButtonList();
		

	},
	computed:{
		allBooks() {
			return JSON.parse(sessionStorage.getItem('allBooks'));
		}
	},
	methods:{
		// 获取角色同步按钮
		getButtonList() {
			 let params={
	          permissions:'ac:allocation:roleToSetOfBook'
	        }
	         this.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
	            if(res && res.data.code == 1) {
	              this.buttonList = res.data.data;
	            }
	         })
		},
		// 保存同步账套
		handleSaveGo() {
			if(!this.isSelectShow) {
				this.modifyUserBy_BForm.setOfBookId = "";
			}
			this.$http.post('sys/role/allocationRoleToSetOfBook',this.modifyUserBy_BForm).then(res=>{
	            if(res && res.data.code == 1) {
	            	this.$message.success(res.data.msg)
	               this.modifyUserBy_B = false;
	            }
	         })
		},
		// 范围时间改变
		handleDataRangeChoiseChange(val) {
			this.modalData.designatedValue = this.$util.formatDate.format(val, 'yyyyMM');
		},
		// 成员/禁用信息移入显示
		handleAllEnter(item,t) {
			if((item.isEnable===0)&&t===0) {
				item.isUserMessageShow = true;
				item.messageNote = "已禁用该用户"
			}else if(item.protectionBook===1&&item.isEnable!==0&&t===0){
				item.isUserMessageShow = true;
				item.messageNote = "该用户需要验证进入"
			}else {
				
				item.isUserMessageShow = true;
				item.messageNote = item.userLoginName;
			}
		},
		//成员/禁用 移出不显示
		handleAllLeave(item) {
			item.isUserMessageShow = false;
			item.messageNote = ""
		},
		// 点击搜索
		getOperationLogs() {
			if(!this.getOperationDataForm.search) return;
			this.timeLineList = [];
			this.getOperationDataForm.currentPage ="1";

			this.getOperationLog();
		},
		// 成员操作
		handleCommand(i) {
			if(!i) return;
			if(i.a==="inEable") {      // 禁用
				let params = {
					accountBookId: i.b.id,
					isEnable: i.b.isEnable===1?0:1,
					type: "1",
				}
				this.$http.post('sys/account/updateIsEnableStateByaccountBookId' , params).then(res=>{
					if(res&&res.data.code==1) {
						this.getAllUserData();
						this.getOperationLog();
						this.$message({
				             type: 'success',
				             message: '设置成功!'
				          });
					}
				})
			}else{
				if(i.a.name === "移除") {
					this.deleteUserTypeByB(i.b);
				}
				if(i.a.name==="修改") {
					this.title = "修改成员";
					this.modifyUser(i.b);
				}
			}
		},
		// 获取全部成员
		getAllUserData() {
			this.$http.post('sys/account/findAllAccount1',{}).then(res=>{
				if(res.data&&res.data.code==1) {
					this.userListData = res.data.data.map(item=>{
						if(item.childList&&item.childList.length) {
							item.childList.forEach(i=>{
								i.firstText = i.userName?i.userName.slice(0,1):"";
								i.isUserMessageShow = false;
								i.messageNote = "";
							})
						}
						return item;
					})
				}
			})
		},
		// 日期变化
		getDataChange() {
			this.timeLineList = [];
			this.getOperationDataForm=Object.assign(this.getOperationDataForm,{
				date:"",
				currentPage:"1",
				start:this.$util.formatDate.format(this.dateList[0], 'yyyy-MM-dd'),
				end:this.$util.formatDate.format(this.dateList[1], 'yyyy-MM-dd')
			})
			this.getOperationLog();
		},
		// 下拉框变化
		handleSelectChange(val) {
			this.timeLineList = [];
			this.getOperationDataForm=Object.assign(this.getOperationDataForm,{
				date:"",
				currentPage:"1",
			})

			this.getOperationLog();
		},
		// 获取操作日志
		getOperationLog() {
			this.timeDataLoading = this.getOperationDataForm.currentPage<=1;
			this.completeText = '正在加载.....'
			this.$http.post('log/getOperationLog',this.getOperationDataForm).then(res=>{
				this.timeDataLoading = false;
				if(res&&res.data.code==1) {
					if(res.data&&res.data.data.data.length) {

						
						let nowData = res.data.data.data.map(i=>{
							if(i.date) {
								i.titleNum = i.date.slice(-3,-1)
							}
							return i;
						})
						// 截取数据
						if(this.timeLineList.length&&nowData.length){
							let lastData = this.timeLineList[this.timeLineList.length-1].date;
							let startData = nowData[0].date;

							if(lastData === startData) {
								let childNode = JSON.parse(JSON.stringify(nowData[0].child));
								nowData.splice(0,1);
								this.timeLineList[this.timeLineList.length-1].child = this.timeLineList[this.timeLineList.length-1].child.concat(childNode);
							}
						}
						this.timeLineList = this.timeLineList.concat(nowData);

						// over=======================================
						this.getOperationDataForm.date = this.timeLineList[0].child[0].date;
						this.getOperationDataForm.currentPage = res.data.data.currentPage+1;
						this.$nextTick(()=>{
							console.log(this.$refs.timeLine.children[0].children[0])
							let dom = this.$refs.timeLine.children[0].children[0];
							if(dom.scrollHeight===dom.clientHeight) {
								this.completeText = '已加载完毕'
							}else {
								this.completeText = '下拉加载更多'
							}
							this.changeLineHeight(this.timeLineList);
						})
					}else {
						this.completeText = '已加载完毕'
					}
				}else {
					this.completeText = '已加载完毕'
				}

			})
		},
		// 获取操作类型
		async getOperationLogType() {
			this.$http.post('log/getOperationLogType',{}).then(res=>{
				this.getOperationLogAccount();
				if(res&&res.data.code==1) {
					this.operationLogTypeList = res.data&&res.data.data?res.data.data:[];
					this.getOperationDataForm.type= this.operationLogTypeList.length?this.operationLogTypeList[0].type:"";
				}

			})
		},
		// 获取全部成员
		async getOperationLogAccount() {
			this.$http.post('log/getOperationLogAccount',{}).then(res=>{
				this.getOperationLogPlate();
				if(res&&res.data.code==1) {
					this.operationLogLogAccountList = res.data&&res.data.data?res.data.data:[];
					this.getOperationDataForm.accountId= this.operationLogLogAccountList.length?this.operationLogLogAccountList[0].id:"";
				}

			})
		},
		// 获取全部模块
		async getOperationLogPlate() {
			this.$http.post('log/getOperationLogPlate',{}).then(res=>{
				if(res&&res.data.code==1) {
					this.operationLogLogPlateList = res.data&&res.data.data?res.data.data:[];
					this.getOperationDataForm.plate= this.operationLogLogPlateList.length?this.operationLogLogPlateList[0].type:"";
					this.getOperationLog();
				}

			})
		},
		// 搜索
		handleSearchEnter() {
			this.isSearchInputShow = false;
		},
		// 返回竖线的高度
		//  returnStyle(e) {
		// 		let str = "deleted_" + e;
		// 		let height = this.$refs[str]&&this.$refs[str].length?this.$refs[str][0].clientHeight*0.8+"px":"40px";
		// 		let obj = {height:height}
		// 		return obj;
		// },
		// 保存成功回调
		handleblurSuccess(data) {
			if(data) {
				this.getUser();
			}
		},
		addUserAdd() {
			const _ = this;
			_.clickActive = "";
			_.roleId = "";
			_.roleInputValue = "";
			_.oldName = "";
			_.$nextTick(()=>{
				_.$refs.roleInput.select();
			})
		},
		
		tjcyClick(){
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.modalData = Object.assign(this.modalData,{
				userLoginName:'',
				userName:'',
				protectionBook:"0",
				dataScope:"1",
				designatedScope:"2",
				designatedValue:"",
				id:""
			}) 
			this.modalData.designatedValue = this.$util.formatDate.format(this.dataRangeChoise , 'yyyyMM'); 
			this.dataRangeChoise = new Date();
			this.dialog.modal = true;
			this.isEditer = false;
			this.title = "添加成员";
		},
		jeglClick(){

			// const prevent =  this.$getSessionStorage('superPreventOperation');
			// if(prevent) {
			// 	this.$store.commit('SUPERPREVENTFUNCTION',true);
			// 	return;
			// }
			this.dialog.modal1 = true
		},
		// 自定义表头
		renderHeader(h,{column}) {
			if(column.property == "protectionBook") {
				return h("div", [
			        h("span", ['开启账套保护']),
			        h("el-tooltip", {
			            attrs: {

			                effect: "light",
			                content: "开启账套保护后，该用户每次切换到该账套时，都会发送验证码到管理员手机，用户必须向管理员索要验证码才可登录。",
			                placement: "bottom"
			            }
			        }, [
			            h("i", {
			                'class': 'iconfont iconproblem table-msg'
			            })
			        ])
			    ])

			}else {
				return column.label
			}
		},
		init(){
			// 获取菜单树
			this.$http.post('sys/menu/getTree',{isButton: '2'}).then(res=>{
				if(res) {

					this.treeDatas = res.data.data;
				}

			})
		},
		// 获取按钮权限
			getButton(){
				let params={
					permissions:'sys:acc:save'
				}
				try {
					this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
						if(res.data.data.length){
							this.buttons = res.data.data;
						}
					})
				}catch(e){

				}
			},
		// 角色下拉框改变事件
		handleChange(val) {
			this.nowRoleId = val;
			this.getUserTable();
		},
		// 按钮操作
		handleOperation(item,row) {
			if(item.name == '修改') {
				// const prevent =  this.$getSessionStorage('superPreventOperation');
				// if(prevent) {
				// 	this.$store.commit('SUPERPREVENTFUNCTION',true);
				// 	return;
				// }
				this.modifyUser(row);
			}else if(item.name == '移除'){
				this.deleteUserTypeByB(row);
			}
		},
		// 修改B类用户弹框
		modifyUser(row) {
			this.modalData = Object.assign(this.modalData,{
				userLoginName:row.userLoginName,
				userName: row.userName,
				id: row.id,
				fkRoleIds: row.fkRoleIds,
				protectionBook:row.protectionBook?row.protectionBook.toString():"0",
				dataScope:row.dataScope,
				designatedScope:row.designatedScope,
				designatedValue:row.designatedValue,
			})
			this.dataRangeChoise = row.designatedValue?row.designatedValue.toString().slice(0,4)+"-"+row.designatedValue.toString().slice(4):new Date();
			this.dialog.modal = true;
			this.isEditer = true;
		},
		// 修改B类用户
		modifyUser_send() {
			this.$http.post('sys/account/updateAccount',this.modalData).then(res=>{
				this.dialog.modal = false;
				if(res && res.data.code == 1) {
					this.$message({
			            type: 'success',
			            message: '修改成功!'
			          });
        			// this.getUserTable();
        			this.getAllUserData();
					this.getOperationLog()

				}
			})
		},
		// 删除B类用户
		deleteUserTypeByB(row) {
			 this.$confirm('此操作将删除当前成员, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		        	this.$http.post('sys/account/deleteFkAccountBookById' , {id: row.id}).then(res=>{
		        		if(res &&res.data.code == 1) {
		        			 this.$message({
					            type: 'success',
					            message: '删除成功!'
					          });
		        			 this.getAllUserData();
							this.getOperationLog()
		        		}
		        	})
		         
		        }).catch(() => {
			          this.$message({
			            type: 'info',
			            message: '已为您取消删除'
			          });          
		        });
			},
		// 是否启用状态改变  开启账套保护2/是否启用1
		handleSwitchChange(row,type) {

			// const prevent =  this.$getSessionStorage('superPreventOperation');
			// if(prevent) {
			// 	this.$store.commit('SUPERPREVENTFUNCTION',true);
			// 	this.getUserTable();
			// 	return;
			// }
			if(type == '1') {
				let params = {
					accountBookId: row.id,
					isEnable: row.isEnables?1:0,
					type: type,
				}
				this.$http.post('sys/account/updateIsEnableStateByaccountBookId' , params).then(res=>{
					if(res) {
						this.$message({
				             type: 'success',
				             message: '设置成功!'
				          });
	        			 this.getUserTable();
					}
				})
			}else if(type == '2') {
				let params = {
					accountBookId: row.id,
					type: type,
					protectionBook: row.protectionBooks?1:0
				}
				this.$http.post('sys/account/updateIsEnableStateByaccountBookId' , params).then(res=>{
					if(res) {
						this.$message({
				             type: 'success',
				             message: '设置成功!'
				          });
	        			 this.getUserTable();
					}
				})
			}
		},
		// 获取角色
		getUser() {
			this.$http.post('sys/role/findAll',{}).then(res=>{
				if(res.data&&res.data.code==1&&res.data.data.length){
					const index = res.data.data.length-1;
					this.userSelectOption = res.data.data;
					this.modalData.fkRoleIds = this.modalData.fkRoleIds.length?this.modalData.fkRoleIds:[res.data.data[0].id];
					this.roleInputValue = this.roleInputValue?this.roleInputValue:res.data.data[index].name;
					this.oldName = this.oldName?this.oldName:res.data.data[index].name;
					this.userSelectOption.forEach(i=>{

						this.isTextShow.push(true)
					})
					// 默认选择第一个
					//this.form.userSelect = res.data.data[index].id;
					// 获取表格数据，默认获取第一个角色的。
					//this.nowRoleId = res.data.data[index].id;
					//this.getUserTable();
					this.clickActive = this.clickActive?this.clickActive:res.data.data[index].id;
					this.roleId = this.roleId?this.roleId:res.data.data[index].id;

					
					// 只会在刷新时执行一次
					if(this.onceBoolean) {
						this.getUserID(res.data.data[index]);
						this.onceBoolean = false;
					}

				}
				
			});
		},
		// 添加B类用户
		addRolesMethod(){
			this.$refs.modalData.validate((valid)=>{
				if(valid) {
					if(this.isEditer) {
						this.modifyUser_send();
						return;
					}
					this.$http.post('sys/account/saveAccount' , this.modalData).then(res=>{
						if(res&& res.data.code==1) {
							this.$message.success('添加成功!');
							this.dialog.modal = false;
							//this.getUserTable();
							this.getAllUserData();
							this.getOperationLog()
						}
					})
				}
			})
			
		},
		// 查询B类用户列表
		getUserTable() {
			return;
			try {
				this.tableData.loading = true;
				this.$http.post('sys/account/findAllAccount' , {roleId: this.nowRoleId}).then(res=>{
					this.tableData.loading = false;
					this.tableData.data = res.data.data.list.map(i=>{
						this.$set( i , 'isEnables' , i.isEnable==1?true:false);
						this.$set( i , 'protectionBooks' , i.protectionBook==1?true:false);
						return i;
					})
				})
			}catch(e) {
				this.tableData.loading = false;
			}
			
		},
		// 保存科目菜单
		saveTree() {
			let res = this.$refs.tree.getCheckedKeys(false);
			let row = this.nowTab;
			let params={
				id: row.id,
				name: row.name,
				menuIds: res
			}
			this.$http.post('sys/role/save',params).then(res=>{
				this.$message({
					type: 'success',
					showClose: true,
					message: res.data.msg
				})
				this.getUserID(row);

			})
		},
		// 失去焦点保存事件
		handleblur(row,index) {
			this.$set(this.isTextShow,index,true)
			if(!row.name) {
				row.name = this.nowName;
				return this.$message({
					type: 'error',
					showClose: true,
					message: '角色名称不能为空！'
				})
			}
			if(row.name == this.nowName) {
				return;
			}
			let params = {
				id: row.id,
				name: row.name,
			}
			try {
				this.$http.post('sys/role/save',params).then(res=>{
					if(res&&res.data.code==1) {
						this.$message({
							type: 'success',
							showClose: true,
							message: res.data.msg
						})
						this.getUser();
					}
					
				})
			}catch(e){

			}finally{

			}
		},
		// 获取焦点选中
		handlefocus(e) {
			e.target.select();
		},
		
		// 根据角色获取科目数权限
		getUserID(item) {
			try {
				this.roleId = item.id;
				this.nowTab = item;
				this.clickActive = item.id; 
				this.roleInputValue = item.name;
				this.oldName = item.name;
				/* this.userLoading = true;
				this.$http.post('sys/role/get',{id: item.id}).then(res=>{
					this.treeChecked = res.data.data.menuIds
					
					this.refresh = false;
					this.$nextTick(()=>{
						this.refresh = true;
						this.userLoading = false;
					})

				}) */
				
			}catch(e){
				this.userLoading = false
			}finally{
				//this.userLoading = false;
			}
			
		},
		// 添加角色
		addUser() {

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			try {
				this.$http.post('sys/role/save',this.userForm).then(res=>{
					if(res&&res.data.code == 1) {
						this.userForm.name = '';
						this.$message({
							type: 'success',
							showClose: true,
							message: res.data.msg
						})
						this.getUser();
					}
					
				})
			}catch(e){

			}finally{

			}
		},
		// 修改角色
		editUser(row,index) {
			
				this.nowName = row.name;
				if(this.isTextShow.length) {
					this.isTextShow.forEach((i,index)=>{
						this.isTextShow[index] = true;
					})
					this.$set(this.isTextShow,index,false)
				}
				this.$nextTick(()=>{
					this.$refs.userInput[0].focus();

				})
			
			
			
		},
		// 删除角色
		deleteUser(row) {
			this.$confirm('此操作您将删除当前角色，是否继续？' , '提示' , {
				confirmButtonText: '确定',
          		cancelButtonText: '取消',
          		 type: 'warning'
			}).then(()=>{
				try {
				this.$http.post('sys/role/deleted',{id: row.id}).then(res=>{
					if(res&&res.data.code==1) {
						this.$message({
							type: 'success',
							showClose: true,
							message: res.data.msg
						})
							this.getUser();
					}
					
					})
				}catch(e){

				}finally{

				}
			}).catch(()=>{
				this.$message({
					type: 'warning',
					showClose: true,
					message: '已为您取消当前操作！'
				})
			})
			
		},
		// 时间线滚动开启分界线
		handleTimeLineScroll(e) {
			let filterTab = this.$refs.filterTab,nowScrollHeight;
			nowScrollHeight = e.target.scrollHeight;
			if(e.target.scrollTop>0) {
				filterTab.style.boxShadow="0 1px 10px #eee"
				if(nowScrollHeight ===(e.target.scrollTop+e.target.clientHeight)) {
					this.getOperationLog();
				}
			}else {
				filterTab.style.boxShadow="none"
			}
		},
		// 动态改变时间线高度
		changeLineHeight(arr) {
			if(arr.length) {
				arr.forEach(item=>{
					if(item.child.length) {
						item.child.forEach(i=>{
							let str = "deleted_" + i.id;
							let str1 = "line_" + i.id;
							let height = this.$refs[str]&&this.$refs[str].length?this.$refs[str][0].clientHeight*0.8+"px":"40px";
							if(this.$refs[str1]&&this.$refs[str1].length){
								this.$refs[str1][0].style.height = height
							}

						})
					}
				})
			}
		}

	},
	watch:{
		'getOperationDataForm.search':{
			handler(val) {
				if(!val) {
					this.getOperationLog();
				}
			},
			deep:true
		},
		'dialog.modal'(val){
			if(val) {
				this.$nextTick(()=>{
					this.$refs.modalData.clearValidate();
				})
			}
		}
	},
	mounted() {
		const _ = this;
		let content = _.$refs.timeLine.children[0].children[0];
		if(content){
			content.addEventListener('scroll',_.handleTimeLineScroll);
		}
	},
	deactivated() {
		let _ = this;
		let content = _.$refs.timeLine.children[0].children[0];
		// 移出滚动监听
		if(content) {
			content.removeEventListener('scroll' , _.handleTimeLineScroll)
		}
	},

}
</script>

<style lang="less">
	@import url('../../assets/css/roles.less');
	#roleAuthorList{
		height: 600px;
		overflow: hidden;
	}
	#userManage{
		position: relative;
		height: calc(100% - 60px);
		.userMangeTitle {
			color: #333333;
			font-size: .30rem;
		}
		.table-msg {
			margin-left: 10px;
			font-size: 14px;
			color: #666666;
		}
		.red {
			color: red;
		}
		.userManage_dialog {
			.el-dialog {
				height: 700px;
			}
		}
		.role-ahouer-list {
			height: 550px;
			overflow: hidden;
			.role-ahouer_container {
				height: 100%;
				width: 100%;
			}
		}
		.manager{
			font-size: 14px;
			color: #666;
			margin-bottom: 20px;
			padding-left: 10px;
		}
		.treeButton {
			margin-top: 20px;
		}
		.default-scrollbar {
			width: 100%;
			height: 100%;
		}
		.el-scrollbar__wrap,.default-scrollbar__wrap {
		  overflow-x: hidden;
		}
		.addRoles {
			line-height: 28px;
		}
		/*switch样式*/
		/*.el-switch__label--left{
		  position: relative;
		  left: 44px;
		  color: #fff;
		  font-size: 14px;
		  z-index: -1111;
		}
		.el-switch__label--right{
		  position: relative;
		  right: 44px;
		  color: #fff;
		  font-size: 14px;
		  z-index: -1111;
		}
		.el-switch__label.is-active{
		  z-index: 1111;
		  color: #fff;
		}
		.el-switch__label--right.is-active{
		  z-index: 1111;
		  color: #fff !important;
		}
		.el-switch__label--left.is-active{
		  z-index: 1111;
		  color: #fff !important;
		}*/
	};
</style>



// WEBPACK FOOTER //
// src/pages/setting/userManage.vue